import { Component, HostListener, OnInit, ViewChild } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { DevExtremeModule } from 'devextreme-angular';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { AppInformationService, AuthService, UtilityService } from 'app/core/core.module';
import { confirm, alert } from 'devextreme/ui/dialog';
import validationEngine from 'devextreme/ui/validation_engine';
import moment from 'moment';
import { smoothlyMenu } from '../../app.helpers';
declare var jQuery: any;

@Component({
    selector: 'app-votes-overview',
    templateUrl: './votes-overview.component.html',
    styleUrls: ['./votes-overview.component.scss'],
    standalone: true,
    imports: [DevExtremeModule],
})
export class VotesOverviewComponent implements OnInit {
    filter: {
        email: string;
        userCode: string;
    };
    codeFilter: {
        email: string;
        budgetBox: string;
        birthDate: Date;
    };
    dateString: string;
    processing = false;
    validationGroup = 'mainValidation';
    codeFilterOptions: any;
    userCode: any;
    proposalInfo: any;
    voteClosed = false;
    screenHeight: number;
    screenWidth: number;
    canDiscuss = false;
    discussion: string;
    discussions: any;

    constructor(private utility: UtilityService, private appInfo: AppInformationService, private router: Router, private auth: AuthService, private route: ActivatedRoute) {
        this.getScreenSize();
    }
    toggleNavigation(): void {
        jQuery('body').toggleClass('mini-navbar');
        smoothlyMenu();
    }

    @HostListener('window:resize', ['$event'])
    getScreenSize(event?) {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
        // console.log(this.screenHeight, this.screenWidth);
    }

    async ngOnInit() {
        this.userCode = this.route.snapshot.params['id'];
        this.appInfo.pleaseWaitShow();
        try {
            await this.getData();
        } catch (error) {}
        this.appInfo.pleaseWaitHide();
        if (this.screenWidth > 850) this.toggleNavigation();
        this.canDiscuss = this.proposalInfo && this.proposalInfo.AllowDiscussion && !this.proposalInfo.Approved && !this.proposalInfo.Declined;

    }

    async getData() {
        this.proposalInfo = await this.utility.getProposal(this.userCode);
        this.discussions = this.proposalInfo.Discussions;
        this.discussions.forEach(x => {
            x.date = moment(x.Created).format('MM/DD/YY')
        });
        this.voteClosed = this.proposalInfo.Approved || this.proposalInfo.Declined;
        this.proposalInfo.voteDate = moment(this.proposalInfo.Voted).format('MM/DD/YYYY');
    }

    async submitVote(yesNoVote: any) {
        const yesVote = yesNoVote === 'Yes';
        const noVote = yesNoVote === 'No';
        this.appInfo.pleaseWaitShow();
        const vote = await this.utility.submitProposalVote(this.userCode, yesVote, noVote);
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async addDiscussion() {
        if (!this.discussion) return;

        const result = await confirm(`Add discussion?`, `${this.appInfo.settings.church.toUpperCase()}`);
        if (!result) return;
        this.appInfo.pleaseWaitShow();
        const vote = await this.utility.submitProposalDiscussion(this.userCode, this.discussion);
        await this.getData();
        this.discussion = null;
        this.appInfo.pleaseWaitHide();
    }


    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }
}
